const FONTS_LIST = [
  { id: 1, label: 'Times New Roman', fontFamily: '"Times New Roman", Times, serif' },
  { id: 2, label: 'Arial', fontFamily: 'Arial, Helvetica, sans-serif' },
  { id: 3, label: 'Courier New', fontFamily: '"Courier New", Courier, monospace' }
]

export { 
  FONTS_LIST
};


// WEBPACK FOOTER //
// ./src/constants/fontsList.js